import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { InputProcessingGroupEventDetailsType } from '../schema/types';
import { ProcessingEventUrl } from './ProcessingEventUrl';
import { OutputProcessingGroupEventDetailsSchema } from '../schema/OutputProcessingGroupEventDetailsSchema';

const getLatestOutputProcessingGroupEvent = (id: number) =>
  apiClient
    .get<InputProcessingGroupEventDetailsType>(
      expand(
        ProcessingEventUrl.LATEST_OUTPUT_PROCESSING_EVENT_BY_PROCESSING_GROUP,
        {
          id,
        }
      )
    )
    .then((response) =>
      OutputProcessingGroupEventDetailsSchema.parse(response.data)
    );

export const useLatestOutputProcessingGroupLatestEventQuery =
  createApiQueryHook(
    ['latestOutputProcessingGroupEvent'],
    getLatestOutputProcessingGroupEvent
  );
